export const CAMPAIGN_STATE = {
    CREATED: "CREATED",
    GENERATING: "GENERATING",
    WAITING: "WAITING",
    UPDATED: "UPDATED",
    STOPPED: "STOPPED",
    ROLLBACK_WAITING: "ROLLBACK_WAITING",
    ROLLBACK_UPDATED: "ROLLBACK_UPDATED",
    FAILED: "FAILED",
    CANCELLED: "CANCELLED",
};
